/**
 * Splits a name into firstName and lastName.
 * Handles two formats:
 *  - "Last, First" (comma) → { firstName: "First", lastName: "Last" }
 *  - "First Last" (space, no comma) → { firstName: "First", lastName: "Last" }
 *
 * For multi-word names without a comma, the first token is treated as the
 * firstName and the remainder as the lastName.
 */
export const splitName = (
  name: string,
): { firstName: string; lastName: string } => {
  if (!name) return { firstName: "", lastName: "" };

  if (name.includes(",")) {
    const [lastPart, firstPart] = name.split(",");
    return {
      firstName: firstPart?.trim() ?? "",
      lastName: lastPart?.trim() ?? "",
    };
  }

  const parts = name.trim().split(/\s+/);
  if (parts.length <= 1) {
    return { firstName: parts[0] ?? "", lastName: "" };
  }
  return { firstName: parts[0], lastName: parts.slice(1).join(" ") };
};
